var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCastle(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 42,
    height: 73,
    viewBox: "0 0 42 73",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.58008 66.7492C3.58008 66.7492 4.76727 61.1508 4.82298 58.2449C4.8787 55.3389 5.25157 55.184 5.25157 55.184C5.25157 55.184 8.94171 51.608 11.0418 44.5566",
    stroke: "#B250FF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M39.2858 66.7494C39.2858 66.7494 38.0986 61.2138 38.0429 58.3455C37.9871 55.4772 37.6143 55.3223 37.6143 55.3223C37.6143 55.3223 33.937 51.7882 31.8369 44.8164",
    stroke: "#B250FF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0347 28.9418C15.2677 31.002 14.072 27.8238 15.212 26.8482C16.3521 25.8726 18.8721 27.7191 19.9265 27.0911",
    stroke: "#B250FF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20.6421 35.1359C31.8839 35.1359 41 32.0122 41 28.1557C41 28.1557 38.6428 28.2939 37.357 27.2471",
    stroke: "#B250FF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M7.53174 33.46L7.71153 35.1851L8.37932 42.2784",
    stroke: "#B250FF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M34.7854 33.3555V33.3597L34.6142 36.4331L34.3916 42.2618",
    stroke: "#B250FF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M33.787 23.2012L37.9314 25.5042C36.7257 26.8046 35.1446 27.7172 33.397 28.1212",
    stroke: "#B250FF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M31.3568 23.7246C31.3568 23.7246 34.0698 22.7113 34.7855 21.8739C35.5013 21.0364 31.0697 19.7802 29.2139 18.7334",
    stroke: "#B250FF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M21.0708 12.8042C21.0708 12.8042 22.7852 12.733 24.8552 14.3409C26.4563 15.4737 28.1641 16.4552 29.9554 17.272C30.0361 17.31 30.1041 17.3694 30.1518 17.4435C30.1994 17.5176 30.2247 17.6033 30.2247 17.6907C30.2247 17.7782 30.1994 17.8639 30.1518 17.938C30.1041 18.0121 30.0361 18.0715 29.9554 18.1095L28.0225 18.725",
    stroke: "#B250FF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M21.3579 35.1359C10.1161 35.1359 1 32.0122 1 28.1557C1 28.1557 3.35723 28.2939 4.64299 27.2471",
    stroke: "#B250FF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M8.21329 23.2012L4.06885 25.5042C4.2484 26.0313 4.51476 26.5264 4.85745 26.9697",
    stroke: "#B250FF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M10.6434 23.7246C10.6434 23.7246 7.93041 22.7113 7.21467 21.8739C6.49893 21.0364 10.9305 19.7802 12.7863 18.7334",
    stroke: "#B250FF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M20.9293 12.8042C20.9293 12.8042 19.2149 12.733 17.1448 14.3409C15.5438 15.4737 13.836 16.4552 12.0446 17.272C11.964 17.31 11.8959 17.3694 11.8483 17.4435C11.8007 17.5176 11.7754 17.6033 11.7754 17.6907C11.7754 17.7782 11.8007 17.8639 11.8483 17.938C11.8959 18.0121 11.964 18.0715 12.0446 18.1095L17.2134 19.6085",
    stroke: "#B250FF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M21.2466 12.8377L21.5077 2.68359",
    stroke: "#B250FF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M20.7152 2.75879C20.7152 2.75879 19.5066 4.91105 13.4807 4.32483C8.29048 3.81817 7.11187 9.88135 7.01758 10.1535C7.01758 10.1535 8.92051 8.05988 12.6278 9.15276C16.3351 10.2456 20.2138 8.73403 21.3581 7.89658",
    stroke: "#B250FF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M22.9608 1.79447C23.0352 0.94887 22.3938 0.20449 21.5283 0.131848C20.6628 0.0592059 19.9009 0.68581 19.8265 1.53141C19.7522 2.37701 20.3935 3.12139 21.259 3.19403C22.1245 3.26667 22.8865 2.64007 22.9608 1.79447Z",
    fill: "#B250FF",
    "custom-rule": "true"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    "custom-rule": "true",
    clipRule: "evenodd",
    d: "M15.902 41.1602C14.8064 41.0116 13.7214 40.7962 12.6533 40.5154C12.6533 39.1629 12.8933 36.5333 14.5948 36.9939C15.992 37.3707 15.9706 40.0632 15.902 41.1602Z",
    fill: "#B250FF"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    "custom-rule": "true",
    clipRule: "evenodd",
    d: "M30.4998 40.3982C29.3449 40.732 28.1658 40.9797 26.9725 41.1393C26.9039 40.0004 26.8868 36.9102 28.6869 36.705C30.4869 36.4998 30.5255 39.3095 30.4998 40.3982Z",
    fill: "#B250FF"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M16.2104 71.9706C16.2104 68.022 16.2619 60.1792 21.5464 60.0494C26.8309 59.9196 26.938 67.8629 26.938 71.8115",
    stroke: "#B250FF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M34.357 42.124C34.357 44.2763 28.5368 46.0224 21.3579 46.0224C14.1791 46.0224 8.35889 44.2763 8.35889 42.124",
    stroke: "#B250FF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M3.62305 66.7988C3.62305 69.2442 8.91182 71.3169 16.1935 71.9994",
    stroke: "#B250FF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M26.9897 71.9701C34.1257 71.2625 39.2859 69.2149 39.2859 66.7988",
    stroke: "#B250FF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCastle);
export default __webpack_public_path__ + "static/media/castle.410f20cedacfbdf1137979210614fe20.svg";
export { ForwardRef as ReactComponent };